
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import StepperTemp from '@/components/StepperTemp/index.vue'
import priceFun from '../../shop/template/priceFun.vue'
import {
  updateStoreShoppingCart,
  addStoreShoppingCart,
  isGoodsValid
} from '@/api/industryMall'
import { Debounce } from '@/core/decorator'
import store from '@/store'
import { asyncDownloadUrl } from '@/utils/util'

@Component({
  name: 'SearchActivityGoodsCard',
  components: {
    StepperTemp,
    priceFun
  }
})
export default class SearchActivityGoodsCard extends Vue {
  @Prop({ default: '1' }) num
  @Prop({ default: [] }) data
  @Prop({ default: false }) isActivityStart!: boolean // 活动是否开始
  @Getter partnerCompanyId!: string
  isShow = true // 显示规格列表

  // 获取最小价格
  get minData() {
    let minPrice = 1000000
    let saleUnitWay = ''
    this.data.packageList.map((item, index) => {
      // let price = Number(item.marketPrice) / item.sellUnit
      let price = Number(item.finalPrice) / item.sellUnit

      if (price < minPrice) {
        minPrice = price
        saleUnitWay = item.sellUnitWay
      }
    })
    let textPrice = minPrice.toFixed(2)
    return { minPrice: textPrice, saleUnitWay }
  }

  /**
   * 处理销售方式
   */
  get handleSellDesc(): string {
    let saleArr = []
    if (this.data.isMultiSpec) {
      saleArr = this.data.packageList.map((item) => {
        return item.packageNameDesc + item.sellUnit + item.sellUnitWay
      })
    } else {
      saleArr = this.data.packageList.map((item) => {
        return item.sellUnit + (item.sellUnitWay || '')
      })
    }
    return saleArr.join('/')
  }

  getBrand () {
    return this.data.goodsTitleList.map(i => i.goodsTitle).filter(Boolean)
  }

  @Watch('data')
  dataChange(val) {
    // console.log('Watch******', val)
    this.getImgBase(this.data.imageUrl)
  }

  mounted () {
    this.getImgBase(this.data.imageUrl)
  }

  async getImgBase (url) {
    if (this.data.urlBase) return
    let urlBase = await asyncDownloadUrl(url)
    if (!urlBase) {
      urlBase = this.$downloadUrl(url)
    }
    // console.log('imgElement------', urlBase.slice(0, 50))
    this.$set(this.data, 'urlBase', urlBase)
  }

  handleGoodsValid() {
    this.$emit('reloadList')
  }

  // 校验商品是否已失效/下架
  isGoodsValid() {
    const params = {
      shopId: this.data.storeId,
      goodsId: this.data.goodsId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          this.$dialog
            .alert({
              message: '商品过期不存在'
            })
            .then(() => {
              this.$emit('reloadList')
            })
          return false
        }
      })
      .catch(() => {
        return false
      })
  }

  /**
   * @description 显示隐藏规格列表
   */
  openChoose() {
    if (this.data.isMultiSpec) {
      this.toDetail(this.data)
    } else {
      this.isShow = !this.isShow
    }
  }
  /**
   * 购物车商品数量改变时，更新购物车
   * @param index 店铺列表下标
   * @param i 店铺商品列表下标
   * @param value 加购商品数量
   */
  @Debounce(300) // 防抖
  changeQuantity(value: number, event: Event) {
    this.isGoodsValid().then((res) => {
      if (res) {
        if (event) {
          this.$shopCarAnimation.show(event)
        }
        this.updateBuyCar(value)
      }
    })
  }

  /**
   * 显示数量加减
   */
  openStep(e) {
    console.log('e', e)
    this.isGoodsValid().then((res) => {
      if (res) {
        this.$shopCarAnimation.show(e)

        this.data.packageList[0].orderQuantity = 1
        this.addStoreShoppingCart()
      }
    })
  }

  // 加入购物车
  addStoreShoppingCart() {
    const param = {
      partnerCompanyId: this.partnerCompanyId,
      storeId: this.data.storeId,
      goodsId: this.data.goodsId,
      packageId: this.data.packageList[0].packageId,
      orderQuantity: 1
    }
    addStoreShoppingCart(param).then((res:any) => {
      store.dispatch('getShopCarNum', this.partnerCompanyId)
    })
  }

  // 更新购物车
  updateBuyCar(orderQuantity: number) {
    const param = {
      partnerCompanyId: this.partnerCompanyId,
      goodsId: this.data.goodsId,
      packageId: this.data.packageList[0].packageId,
      storeId: this.data.storeId,
      orderQuantity
    }
    updateStoreShoppingCart(param).then((res:any) => {
      store.dispatch('getShopCarNum', this.partnerCompanyId)
    })
  }

  // 跳转商品详情
  toDetail(item: any) {
    if (!this.isActivityStart) return
    this.isGoodsValid().then((res) => {
      if (res) {
        this.$router.push({
          path: '/goodsMallDetail',
          query: {
            goodsId: item.goodsId,
            storeId: item.storeId
          }
        })
      }
    })
  }
}
